import config from 'config';

const LOAD = 'horse-racing/mostfollowed/LOAD';
const LOAD_SUCCESS = 'horse-racing/mostfollowed/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/mostfollowed/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function load(type) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(config.api.horseRacing.mostFollowed[type])
  };
}

export function isLoading(state) {
  return state.horseRacing
      && state.horseRacing.mostFollowed
      && state.horseRacing.mostFollowed.loading;
}

export function get(state) {
  return {mostFollowed: state.horseRacing.mostFollowed.list};
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/mostfollowed.js